export default "__VITE_ASSET__CiWZreN2__"